import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider } from 'styled-components';
import * as ds from './util/DesignSystem';
import { RecoilRoot } from 'recoil';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={ds}>
    <RecoilRoot>
      <App />
    </RecoilRoot>
  </ThemeProvider>
);
